/* Nora v1: no customer/cart data, secrets, cookies or transcript cross this frame boundary. */
(()=>{
 'use strict';
 const root=document.getElementById('kneva-nora'),panel=document.getElementById('kneva-nora-panel'),launch=document.getElementById('kneva-nora-launcher'),close=document.getElementById('kneva-nora-close'),slot=document.getElementById('kneva-nora-frame-slot'),fallback=document.getElementById('kneva-nora-fallback');
 if(!root||!panel||!launch||!close||!slot||!fallback)return;
 const origin='https://kitchen.kneva.co',zh=root.dataset.language.startsWith('zh');
 let frame=null,ready=false,timer;
 function visibility(){if(frame?.contentWindow)frame.contentWindow.postMessage({v:1,type:'kneva-nora-visibility',open:panel.open},origin);}
 function hide(){panel.close();launch.setAttribute('aria-expanded','false');visibility();launch.focus();}
 function unavailable(){if(ready)return;fallback.hidden=false;fallback.textContent=zh?'Nora 暂时未能连接，请通过以下链接联系团队或打开我的厨房。':'Nora is taking longer to connect. Our team can help on WhatsApp, or you can open My Kitchen below.';}
 launch.addEventListener('click',()=>{
  if(typeof panel.showModal!=='function'){window.open('https://kitchen.kneva.co/','_blank','noopener,noreferrer');return;}
  panel.showModal();launch.setAttribute('aria-expanded','true');close.focus();
  if(!frame){
   frame=document.createElement('iframe');frame.title=zh?'Nora 访客文字聊天':'Nora guest text chat';frame.src=origin+'/nora/widget?lang='+(zh?'zh-CN':'en');frame.referrerPolicy='strict-origin-when-cross-origin';frame.addEventListener('error',()=>{ready=false;root.classList.remove('kneva-nora-ready');unavailable();});slot.appendChild(frame);
   timer=setTimeout(unavailable,12000);
  }
  visibility();
 });
 close.addEventListener('click',hide);
 panel.addEventListener('cancel',e=>{e.preventDefault();hide();});
 panel.addEventListener('close',()=>{launch.setAttribute('aria-expanded','false');visibility();});
 window.addEventListener('message',e=>{
  if(e.origin!==origin||e.source!==frame?.contentWindow||e.data?.v!==1)return;
  if(e.data.type==='kneva-nora-ready'){ready=true;clearTimeout(timer);fallback.hidden=true;root.classList.add('kneva-nora-ready');visibility();}
  if(e.data.type==='kneva-nora-close')hide();
 });
})();
